module.exports = __webpack_public_path__ + "static/media/ra-target-small.c64fe2b1.png";